import Vue from 'vue';
import store from '../stores/index';

export function translate (key, ...args) {
  const data = store.state.lang.texts;
  const lang = store.state.lang.currentLang;
  let value = getValue(data, `${lang}.${key}`);
  if (value === null) {
    return key;
  }
  if (args.length === 0) {
    return value;
  }
  for (const argValue of args) {
    value = value.replace('%s', argValue);
  }
  return value;
}

Vue.prototype.$t = translate;

function getValue(data, path) {
  const keys = path.split('.');
  if (keys.length === 1) {
    return data[keys[0]];
  }
  const current = keys.shift();
  if (data[current] === undefined) {
    return null;
  }
  return getValue(data[current], keys.join('.'));
}



// WEBPACK FOOTER //
// ./src/plugins/translate.plugin.js